'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = {
    timeout: 10000,
    disables: [],
    enables: ["x5"],
    urlParamNames: [], // custom
    cacheType: "cookie",
    cookieNames: ["locallat", "locallng"],
    storageName: "whereami",
    wxAutoConfig: false,
    city: false,
    source: "",
    sampling: 0.5, // 自定义采样率，与source配合使用
    debug: false,
    enableHighAccuracy: true // 是否要求高精度的地理信息
};

var get = function get(key) {
    return _config[key];
};

var set = function set(key, value) {
    _config[key] = value;
};

var config = function config(obj) {
    Object.keys(obj).forEach(function (key) {
        _config[key] = obj[key];
    });
};

config.get = get;
config.set = set;

var BASEURLPARAMGROUP = [["latitude", "longitude", "geotype"], // dp
["lat", "lng", "geotype"] // mt
];

function URL() {
    this.type = 'url';
    this.keeper = undefined;
    this.allowdCoordtype = ['wgs84', 'gcj02'];
}
URL.prototype.initData = function () {
    this.query = location.search;
    this.urlParamGroup = [config.get('urlParamNames')].concat(BASEURLPARAMGROUP); // 自定义参数优先级高
};
URL.prototype.syncProcess = function () {
    this.initData();
    return this.match(this.query, this.urlParamGroup);
};
URL.prototype.process = function (succ, fail, next) {
    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    try {
        this.initData();
        var position = this.match(this.query, this.urlParamGroup);
        if (!position) return next(); // 不匹配
        succ(_extends({ type: this.type }, position), opt.token);
    } catch (e) {
        fail({
            code: 400,
            message: e && e.message || JSON.stringify(e),
            type: this.type
        }, opt.token);
    }
};
URL.prototype.match = function (query, matchGroup) {
    var result = void 0;
    if (!query || !matchGroup) return result;
    for (var i = 0; i < matchGroup.length; i++) {
        if (!matchGroup[i].length) continue;
        if (!matchGroup[i][0] || !matchGroup[i][1]) continue;
        var latReg = new RegExp('[?&]' + matchGroup[i][0] + '=([^$&]+)'),
            lngReg = new RegExp('[?&]' + matchGroup[i][1] + '=([^$&]+)'),
            coordtypeReg = new RegExp('[?&]' + (matchGroup[i][2] || 'geotype') + '=([^$&]+)');
        var latMatch = query.match(latReg),
            lngMatch = query.match(lngReg),
            coordtypeMatch = query.match(coordtypeReg);
        if (latMatch && lngMatch && !isNaN(latMatch[1]) && !isNaN(lngMatch[1])) {
            result = {
                lat: latMatch[1],
                lng: lngMatch[1]
            };
            if (coordtypeMatch && ~this.allowdCoordtype.indexOf(coordtypeMatch[1])) {
                // url自定义经纬度、坐标系
                result.geoType = coordtypeMatch[1];
            } else if (/(dp\/com\.dianping)|(meituan)/.test(navigator.userAgent)) {
                // app 注入经纬度，默认坐标系
                result.geoType = /meituan/.test(navigator.userAgent) ? 'gcj02' : 'wgs84';
            }
            break;
        }
    }
    return result;
};
URL.prototype.noop = function () {};

var instance = new URL();
var _interface = instance.process.bind(instance);
_interface.syncAPI = instance.syncProcess.bind(instance);
_interface.type = instance.type;

/*!
 * refer  jquery.cookie
 * https://github.com/carhartl/jquery-cookie
 *
 */
var isFunction = function isFunction(obj) {
    return Object.prototype.toString.call(obj) == '[object Function]';
};
var extend = function extend(obj) {
    Array.prototype.slice.call(arguments, 1).forEach(function (source) {
        if (source) {
            for (var prop in source) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

var pluses = /\+/g;

function encode(s) {
    return config$2.raw ? s : encodeURIComponent(s);
}

function decode(s) {
    return config$2.raw ? s : decodeURIComponent(s);
}

function stringifyCookieValue(value) {
    return encode(config$2.json ? JSON.stringify(value) : String(value));
}

function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
        // This is a quoted cookie as according to RFC2068, unescape...
        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
        // Replace server-side written pluses with spaces.
        // If we can't decode the cookie, ignore it, it's unusable.
        // If we can't parse the cookie, ignore it, it's unusable.
        s = decodeURIComponent(s.replace(pluses, ' '));
        return config$2.json ? JSON.parse(s) : s;
    } catch (e) {}
}

function read(s, converter) {
    var value = config$2.raw ? s : parseCookieValue(s);
    return isFunction(converter) ? converter(value) : value;
}

var cookie;
var config$2;
var removeCookie;

config$2 = cookie = function cookie(key, value, options) {

    // Write

    if (value !== undefined && !isFunction(value)) {
        options = extend({}, config$2.defaults, options);

        if (typeof options.expires === 'number') {
            var days = options.expires,
                t = options.expires = new Date();
            t.setTime(+t + days * 864e+5);
        }

        return document.cookie = [encode(key), '=', stringifyCookieValue(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
        var parts = cookies[i].split('=');
        var name = decode(parts.shift());
        var cookie = parts.join('=');

        if (key && key === name) {
            // If second argument (value) is a function it's a converter...
            result = read(cookie, value);
            break;
        }

        // Prevent storing a cookie that we couldn't decode.
        if (!key && (cookie = read(cookie)) !== undefined) {
            result[name] = cookie;
        }
    }

    return result;
};

config$2.defaults = {};

removeCookie = function removeCookie(key, options) {
    if (cookie(key) === undefined) {
        return false;
    }

    // Must not alter options, thus extending a fresh object...
    cookie(key, '', extend({}, options, { expires: -1 }));
    return !cookie(key);
};
cookie.remove = removeCookie;
var cookie$1 = cookie;

// 缓存策略(读/写): 内存 > cookie / localStorage
var COOKIE = 'cookie';
var STORAGE = 'storage';
var GEOTYPEKEY = 'geoType';

function Cache() {
    this.type = 'cache';
    this.cacheDuration = 15 * 60 * 1000;
    this.isSupportLS = this.supportLocalStorage();
    this.positionMemory = {};
}

Cache.prototype.initData = function () {
    this.cacheType = config.get('cacheType');
    this.disabled = !!~config.get('disables').indexOf('cache');
    this.storageKey = config.get('storageName');
    this.cookieKey = config.get('cookieNames');
    this.isSupportCity = config.get('city');
};
Cache.prototype.process = function (succ, fail, next) {
    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    // API禁用逻辑在外层，此处不做冗余判断
    // 数据初始化
    this.initData();

    // 组件：默认使用内存
    var result = this.getFromMemory();
    if (result) return succ(_extends(result, { type: this.type }), opt.token);

    // 业务：指定缓存类型
    if (this.cacheType == COOKIE) {
        result = this.getFromCookie();
    } else if (this.cacheType == STORAGE) {
        result = this.getFromStorage();
    } else {
        return next(); // 不匹配
    }
    if (result) return succ(_extends(result, { type: this.type }), opt.token);
    fail({
        code: 412, // 未命中
        type: this.type
    }, opt.token);
};
Cache.prototype.syncProcess = function () {
    this.initData();
    if (this.disabled) return;
    if (this.cacheType === COOKIE) {
        return this.getFromCookie();
    } else if (this.cacheType === STORAGE) {
        return this.getFromStorage();
    }
};
Cache.prototype.store = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 数据初始化
    this.cacheType === undefined && this.initData();
    if (this.disabled) return;

    // 默认使用内存
    _extends(this.positionMemory, position);
    this.positionMemory.startTime = this.positionMemory.startTime || Date.now(); // 设置过期时间

    // 来自Cache的数据不再存储
    if (position.type == this.type) return;

    // 校验
    if (!this.validate(position)) return;

    if (this.cacheType === COOKIE) {
        this.storeCookie(position);
    } else if (this.cacheType === STORAGE) {
        this.storeLocalStorage(position);
    }
};
Cache.prototype.getFromMemory = function () {
    // 校验
    if (new Date() - (this.positionMemory.startTime || new Date()) < this.cacheDuration && this.validate(this.positionMemory)) {
        return this.positionMemory;
    }
    return false;
};
Cache.prototype.getFromStorage = function () {
    if (!this.isSupportLS) return false;
    var ret = localStorage.getItem(this.storageKey);
    if (!ret) return false;
    try {
        ret = JSON.parse(ret);
        typeof ret.city == 'string' && (ret.city = JSON.parse(ret.city));
        if (new Date() - (ret.startTime || new Date()) < this.cacheDuration && this.validate(ret)) {
            return ret;
        }
        localStorage.removeItem(this.storageKey);
        return false;
    } catch (e) {
        return false;
    }
};
Cache.prototype.getFromCookie = function () {
    if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return false;
    var ret = {
        lat: cookie$1(this.cookieKey[0]),
        lng: cookie$1(this.cookieKey[1]),
        geoType: cookie$1(GEOTYPEKEY) // 说明
    };
    if (!this.validate(ret)) return false;
    var backup = this.isSupportCity && this.getFromStorage();
    if (backup && backup.lat == ret.lat && backup.lng == ret.lng) {
        return backup;
    } else {
        return ret;
    }
};
Cache.prototype.validate = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (parseFloat(position.lat) && parseFloat(position.lng)) {
        return true;
    }
    return false;
};
Cache.prototype.storeCookie = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    position = _extends({}, position); // FIXME: 引用参数
    if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return;

    var setting = {
        expires: this.cacheDuration / 1000 / 3600 / 24,
        path: '/',
        domain: this.getCookieDomain()
    };
    cookie$1(this.cookieKey[0], position.lat, setting);
    cookie$1(this.cookieKey[1], position.lng, setting);
    cookie$1(GEOTYPEKEY, position.geoType, setting);

    if (this.isSupportCity && position.city) {
        /**
         * cookie不直接存储city信息 -> 1.非通用 2.数据重
         * 暂时用localStorage存储, key一致 -> 两种方式是互斥的, 不冲突
         */
        position.city = JSON.stringify(position.city); // FIXME: 嵌套对象单独处理, 线上转义: 未知原因(xss?)
        this.isSupportLS && localStorage.setItem(this.storageKey, JSON.stringify(position)); // 不再设置过期时间
    }
};
Cache.prototype.storeLocalStorage = function () {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.isSupportLS) return;

    var ret = _extends({}, position);
    ret.startTime = +new Date();
    localStorage.setItem(this.storageKey, JSON.stringify(ret));
};
Cache.prototype.supportLocalStorage = function () {
    // iphone safari 无痕模式下设置localStorage时候会抛异常
    var testKey = 'local_test';
    try {
        localStorage.setItem(testKey, 1);
        localStorage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
};
Cache.prototype.getCookieDomain = function () {
    // TODO: .meituan.com .meituan.net域名
    var hostname = location.hostname;
    if (/.*\.51ping\.com$/.test(hostname)) {
        return '.51ping.com';
    } else if (/.*\.dianping\.com$/.test(hostname)) {
        return '.dianping.com';
    } else {
        return hostname;
    }
};
Cache.prototype.noop = function () {};

var instance$1 = new Cache();
var _interface$1 = instance$1.process.bind(instance$1);

_interface$1.set = instance$1.store.bind(instance$1);
_interface$1.syncAPI = instance$1.syncProcess.bind(instance$1);
_interface$1.type = instance$1.type;

/**
 * API 调用过程中的 Token Keeper:
 * token: 某次调用的timestamp, token 阅后即焚 -> 保证不重复调用
 * timeout: API超时 -> token 失效
 * trigger: 超时回调
 */
function Keeper() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : opt,
        type = _ref.type,
        token = _ref.token,
        timeout = _ref.timeout,
        trigger = _ref.trigger;

    this.token = token;
    if (token && parseInt(timeout)) {
        this._timeout = setTimeout(function () {
            typeof trigger == 'function' && trigger(_this.token);
            _this.token = null;
        }, timeout);
    }
}
Keeper.prototype.getToken = function () {
    var ret = this.token;
    if (!ret) return ret; // 计时器结束/token被读过了
    clearTimeout(this._timeout); // 结束计时
    this.token = null; // 销毁
    return ret;
};

var Promise = window.Promise || require('promise');
var KNB = window.KNB;

function App() {
    this.type = 'app'; // 收归`dianping`、`meituan`，CAT中请用容器区分
    this.GEOTYPE = ['wgs84', 'gcj02'];
    this.keeper = undefined;
}

App.prototype.process = function (succ, fail, next) {
    var _this2 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        fail({
            // code: 408, // 说明：定位超时放弃兜底方案，与API超时结果处理一致
            message: _this2.type + " API Timeout:" + opt.timeout + "ms",
            type: _this2.type
        }, token);
    };
    this.keeper = new Keeper(opt);

    Promise.resolve(KNB || this.initSDK()).then(function () {
        KNB.ready(function () {
            var KNBP = KNB.getPromiseInstance();
            KNBP.isApiSupported({
                apiName: 'getLocation'
            }).then(function (isSupported) {
                if (isSupported) {
                    return KNBP.getLocation({
                        timeout: opt.timeout / 1000,
                        cache: false
                    });
                } else {
                    fail({
                        code: 412, // API不支持走兜底方案
                        type: _this2.type
                    }, _this2.keeper.getToken());
                }
            }, function () {
                fail({
                    code: 412, // API不支持走兜底方案
                    type: _this2.type
                }, _this2.keeper.getToken());
            }).then(function (ret) {
                ret && succ({
                    lat: ret.lat,
                    lng: ret.lng,
                    geoType: _this2._parseGeoType(ret.type),
                    type: _this2.type
                }, _this2.keeper.getToken());
            }, function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                /**
                 * JSB API结果：未授权(-100)、API超时(-101)、定位错误
                 * SDK策略覆盖GPS WIFI 基站等（不包含IP），成功率高于补位API，后者可能会有奇怪的授权弹框
                 */
                fail({
                    message: e.errorMsg || 'app geo error',
                    type: _this2.type
                }, _this2.keeper.getToken());
            }).catch(function (e) {
                // 异常
                fail({
                    code: 400,
                    message: e && e.message || JSON.stringify(e),
                    type: _this2.type
                }, _this2.keeper.getToken());
            });
        });
    });
};
App.prototype.initSDK = function () {
    return new Promise(function (resolve) {
        require.ensure([], function () {
            KNB = require('@dp/knb/bundle');
            resolve();
        }, 'whereami-knb');
    });
};
App.prototype.supportGeo = function () {
    return this._inDPAPP() || this._inMTAPP();
};
App.prototype._inDPAPP = function () {
    return (/dp\/com\.dianping/.test(navigator.userAgent)
    );
};
App.prototype._inMTAPP = function () {
    return (/meituan/.test(navigator.userAgent)
    );
};
App.prototype._parseGeoType = function (type) {
    if (type && isNaN(type) && ~this.GEOTYPE.indexOf(type.toLowerCase())) {
        // string
        return type.toLowerCase();
    } else if (parseInt(type) || parseInt(type) === 0) {
        // number
        return this.GEOTYPE[parseInt(type)];
    }
    // default
    return this.GEOTYPE[this._inMTAPP() ? 1 : 0];
};

var instance$2 = new App();
var _interface$2 = instance$2.process.bind(instance$2);
_interface$2.type = instance$2.type;

function Weixin() {
    this.type = 'weixin';
    this.keeper = undefined;
}
Weixin.prototype.process = function (succ, _fail, next) {
    var _this3 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof _fail == 'function' || (_fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        // API超时、用户拒绝授权
        _fail({
            code: 408,
            message: _this3.type + " API Timeout:" + opt.timeout,
            type: _this3.type
        }, token);
    };
    this.keeper = new Keeper(opt);

    this.initSDK(function () {
        try {
            // 说明: `回调未执行`先用超时来统计，包含两部分 -> checkJsApi & getLocation
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ['getLocation'],
                    success: function success(res) {
                        if (res.checkResult && res.checkResult.getLocation) {
                            wx.getLocation({
                                type: 'wgs84',
                                success: function success(res) {
                                    succ({
                                        lat: res.latitude,
                                        lng: res.longitude,
                                        type: _this3.type
                                    }, _this3.keeper.getToken());
                                },
                                fail: function fail() {
                                    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                    // TODO: 用户授权失败标识
                                    _fail({
                                        message: e.message || e.errMsg || JSON.stringify(e),
                                        type: _this3.type
                                    }, _this3.keeper.getToken());
                                }
                            });
                        } else {
                            // 说明：config中未匹配的域名、jsApiList没有指定`getLocation`都进入此分支
                            _fail({
                                code: 400,
                                message: 'wx checkJsApi error',
                                title: 'weixin-checkJsApi',
                                type: _this3.type
                            }, _this3.keeper.getToken());
                        }
                    },
                    fail: function fail() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        _fail({
                            code: 400,
                            message: e.message || e.errMsg || 'wx checkJsApi fail',
                            title: 'weixin-checkJsApi',
                            type: _this3.type
                        }, _this3.keeper.getToken());
                    }
                });
            });
            // TODO: 可能有误操作，beta
            wx.error(function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                console.log('wx config error');
                _fail({
                    code: 400,
                    message: e.message || e.errMsg || 'wx config error',
                    title: 'weixin-config',
                    type: _this3.type
                }, _this3.keeper.getToken());
            });
        } catch (e) {
            console.log('wx exception');
            _fail({
                code: 400,
                message: 'wx init error',
                type: _this3.type
            }, _this3.keeper.getToken());
        }
    });
};
Weixin.prototype.initSDK = function (action) {
    if (config.get('wxAutoConfig') && typeof wx === 'undefined') {
        // 说明：同一个url仅需验证一次
        require.ensure([], function () {
            var loader = require('@dp/weixin-js-sdk-loader');
            loader.use(action);
        }, 'whereami-weixin');
    } else {
        action();
    }
};
Weixin.prototype.supportGeo = function () {
    return (/MicroMessenger/.test(navigator.userAgent)
    );
};

var instance$3 = new Weixin();
var _interface$3 = instance$3.process.bind(instance$3);
_interface$3.type = instance$3.type;

var cached = [];

function loadScript(src, cb) {
    if (~cached.indexOf(src)) {
        cb();
        return;
    }

    var script = document.createElement("script");
    script.src = src;
    script.onload = function () {
        cached.push(src);
        cb();
    };
    document.getElementsByTagName("head")[0].appendChild(script);
}

var Util = { loadScript: loadScript

    /**
     * 手Q官方文档：http://open.mobile.qq.com/api/common/index
     */
};function MobileQQ() {
    this.type = 'mobileqq';
    this.keeper = undefined;
}
MobileQQ.prototype.supportGeo = function () {
    return (/(.*?(iPad|iPhone|iPod).*?QQ\/([\d\.]+).*?)|(.*?\bV1_AND_SQI?_([\d\.]+)(.*?QQ\/([\d\.]+))?.*?)/i.test(navigator.userAgent)
    );
};
MobileQQ.prototype.process = function (succ, fail, next) {
    var _this4 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        // API超时
        fail({
            code: 408,
            message: _this4.type + " API Timeout:" + opt.timeout,
            type: _this4.type
        }, token);
    };

    this.keeper = new Keeper(opt);

    Util.loadScript('//open.mobile.qq.com/sdk/qqapi.wk.js?_bid=152', function () {
        try {
            if (!mqq.support('mqq.sensor.getLocation')) return fail({
                code: 412, // API不支持归类为`未命中`
                type: _this4.type
            }, _this4.keeper.getToken());
            mqq.sensor.getLocation({
                allowCacheTime: 60 // 设置缓存时间（秒）
            }, function (retCode, latitude, longitude, status) {
                if (retCode == 0 && latitude && longitude) {
                    succ({
                        lat: latitude,
                        lng: longitude,
                        geoType: 'gcj02',
                        type: _this4.type
                    }, _this4.keeper.getToken());
                } else {
                    var msg = ["retCode:" + retCode];
                    if (status) {
                        // FIXME: >= IOS 4.7
                        msg.push("authroized:" + status.authroized);
                        msg.push("sensor:" + status.enabled);
                    }
                    fail({
                        // code: status && !status.authroized ? 401 : 500, // TODO: authroized为Number类型，与文档不符合
                        code: status && !status.enabled && 407,
                        message: msg.join(' '),
                        type: _this4.type
                    }, _this4.keeper.getToken());
                }
            });
        } catch (e) {
            fail({
                code: 400,
                message: e && e.message || JSON.stringify(e),
                type: _this4.type
            }, _this4.keeper.getToken());
        }
    });
};

var instance$4 = new MobileQQ();
var _interface$4 = instance$4.process.bind(instance$4);
_interface$4.type = instance$4.type;

function LBS() {
    this.type = 'x5';
    this.keeper = undefined;
}
LBS.prototype.supportGeo = function () {
    return (/TBS/i.test(navigator.userAgent) && ~config.get('enables').indexOf('x5')
    ); // 组件策略：目前只对X5内核开放
};
LBS.prototype.process = function (succ, fail, next) {
    var _this5 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        // API超时
        fail({
            code: 408,
            message: _this5.type + " API Timeout:" + opt.timeout,
            type: _this5.type
        }, token);
    };
    this.keeper = new Keeper(opt);

    Util.loadScript('//apis.map.qq.com/tools/geolocation/min?key=6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ&referer=大众点评M站', function () {
        try {
            var x5Geo = new qq.maps.Geolocation('6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ', '大众点评M站');
            x5Geo.getLocation(function (location) {
                succ({
                    lat: location.lat,
                    lng: location.lng,
                    geoType: 'gcj02', // 坐标系类型
                    type: _this5.type
                }, _this5.keeper.getToken());
            }, function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                fail({
                    code: 404, // 可选的定位方式，特殊状态码
                    message: e.message || JSON.stringify(e),
                    type: _this5.type
                }, _this5.keeper.getToken());
            }, {
                timeout: opt.timeout
            });
        } catch (e) {
            // 同步异常
            fail({
                code: 400,
                message: e && e.message || JSON.stringify(e),
                type: _this5.type
            }, _this5.keeper.getToken());
        }
    });
};
LBS.prototype.noop = function () {};

var instance$5 = new LBS();
var _interface$5 = instance$5.process.bind(instance$5);
_interface$5.type = instance$5.type;

function xhr2(url) {
    var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var data = arguments[2];
    var callback = arguments[3];

    if (!url) return;
    typeof callback == 'function' || (callback = noop);

    var xhr = new XMLHttpRequest();

    xhr.open('POST', url);
    if (typeof xhr.setRequestHeader == 'function' && header.length) {
        header.map(function (item) {
            xhr.setRequestHeader(item.name, item.value);
        });
    } else {}
    xhr.send(JSON.stringify(data));
    _addListener(xhr, 'loadend', callback); // FIXME: 结果由业务处理，组件只保证触发回调
}

function noop() {}

function _addListener(target, event, callback) {
    if (target && event) {
        if (addEventListener) {
            target.addEventListener(event, function evtHandler(e) {
                typeof callback == 'function' && callback(e);
                target.removeEventListener(event, evtHandler); // 说明：特定的业务场景，手动移除事件监听（once）
            });
        } else if (attachEvent) {
            // 兼容IE
            target.attachEvent('on' + event, function evtHandler(e) {
                typeof callback == 'function' && callback(e);
                target.detachEvent(event, evtHandler);
            });
        } else {}
    }
}

var PROJECTNAME = 'whereami';
var BASESAMPLE = 0.5; // 组件内置的日志上报率
var FILTERCODE = [201, 409, 416]; // 需要过滤的code

function LogCenter() {
    this.stack = []; // 初始化Log栈队列(异步模式下暂存日志对象)
    this.initSDK();
    this.debug = /debug/i.test(location.search);

    this.defaultTag = 'stage';
    this.normalPrefix = 'whereami-type-' + (this.debug ? 'debug-' : '');
    this.errorPrefix = 'whereami-fail-' + (this.debug ? 'debug-' : '');
}
LogCenter.prototype.initSDK = function () {
    var _this6 = this;

    var Owl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.Owl;

    if (!Owl) {
        // 异步加载npm版本owl
        return require.ensure([], function () {
            _this6.debug && console.log('load owl async');
            Owl = require('@dp/owl');
            _this6.initSDK(Owl);
            _this6.dispatch();
        }, 'whereami-owl');
    }
    this.owl = new Owl.OWL({
        devMode: /51ping.com/i.test(location.hostname),
        project: PROJECTNAME,
        resource: {
            sampleApi: 1 // 说明：实际采样率由`this.sampleValid`控制
        }
    });
};
LogCenter.prototype.initData = function () {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.stack = [];
    this.source = config.get('source').trim();
    this.sample = config.get('sampling');
    opt.normalPrefix && (this.normalPrefix = opt.normalPrefix);
    opt.errorPrefix && (this.errorPrefix = opt.errorPrefix);
    // 上报率控制阀：针对一次完整调用
    this.random = Math.random();
    this.sampleValid = this.randomSample(BASESAMPLE); // 组件级开关，上报率内置
    this.customSampleValid = !!this.source && this.randomSample(this.sample); // 自定义业务开关
};
LogCenter.prototype.dispatch = function () {
    var _this7 = this;

    this.stack.map(function (log) {
        if (log.type == 'err') {
            _this7.logError.apply(_this7, log.params);
        } else {
            _this7.log.apply(_this7, log.params);
        }
    });
};
LogCenter.prototype.log = function () {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
    var name = arguments[3];
    var endTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Date.now();

    if (!!~FILTERCODE.indexOf(code) || !(this.sampleValid || this.customSampleValid)) return;
    name = name || this.normalPrefix + type; // 默认用渠道名, 接受自定义(某些特殊的地方，组件级)
    if (!this.owl) {
        // stack
        return this.stack.push({
            params: [startTime, code, type, name, endTime] // 手动填充: 新增endTime，并向前兼容
        });
    }
    code = code == true ? 200 : code == false ? 500 : code; // 状态码：向前兼容
    // 组件统计
    this.sampleValid && this.owl.addApi({
        name: this.withTag(name, this.defaultTag),
        statusCode: code,
        responseTime: endTime - startTime // 时间
    });
    // 业务统计
    this.customSampleValid && this.owl.addApi({
        name: this.withTag(name, this.source),
        statusCode: code,
        responseTime: endTime - startTime
    });
};
LogCenter.prototype.logError = function () {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
    var name = arguments[2];

    if (!this.sampleValid && !this.customSampleValid) return; // v2.1 开始与`log`同比采样
    name = name || this.errorPrefix + type;
    if (!this.owl) {
        // stack
        return this.stack.push({
            type: 'err',
            params: arguments
        });
    }
    // 组件统计
    this.sampleValid && this.owl.addError({
        name: this.withTag(name, this.defaultTag),
        msg: err.message
    });
};
LogCenter.prototype.logService = function () {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var data = {
        model: 'h5',
        reqid: 1, // 请求的ID
        lastloc: {
            accu: -1, // 误差半径
            age: new Date() - startTime,
            lat: position.lat,
            lon: position.lng,
            coordtype: /wgs84/i.test(position.geoType) ? 0 : 1
        },
        version: '2.1.0', // 固定值
        address_language: '',
        appname: 'whereami',
        request_address: true,
        auth_key: 'GY7A10rxJfxi066yuEppbAJBSruNp6xt', // 授权码
        osver: '', // 系统版本号
        nettype: 'Mobile',
        deviceid: cookie$1('_hc.v')
    };
    xhr2('//apimobile.meituan.com/locate/v2/sdk/loc?ci=whereami', [{
        name: 'Content-Type',
        value: 'application/json'
    }], data, function (e) {});
};
LogCenter.prototype.randomSample = function (threshold) {
    if ((this.random || Math.random()) < threshold) {
        return true;
    }
    return false;
};
LogCenter.prototype.withTag = function (origin, tag) {
    var split = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

    if (!tag) return origin;
    if (!origin) return;
    return origin + split + tag;
};

var instance$6 = new LogCenter();
var Log = instance$6.log.bind(instance$6);
var LogError = instance$6.logError.bind(instance$6);
var LogClean = instance$6.initData.bind(instance$6);
var LogService = instance$6.logService.bind(instance$6);

function QQBrowser() {
    this.type = 'qqbrowser';
    this.keeper = undefined;
}
QQBrowser.prototype.supportGeo = function () {
    return (/MQQBrowser(?!(.*TBS))/.test(navigator.userAgent)
    ); // x5内核微信、QQ客户端关闭该补位方式，出错率95%+
};
QQBrowser.prototype.process = function (succ, fail, next) {
    var _this8 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        // API超时
        fail({
            code: 408,
            message: _this8.type + " API Timeout:" + opt.timeout,
            type: _this8.type
        }, token);
    };
    this.keeper = new Keeper(opt);

    Util.loadScript('//jsapi.qq.com/get?api=app.getGeoLocation', function () {
        try {
            browser.app.getGeoLocation(function (res) {
                if (res && res.ret === 'true') {
                    succ({
                        lat: res.latitude,
                        lng: res.longitude,
                        type: _this8.type
                    }, _this8.keeper.getToken());
                } else {
                    fail({
                        message: 'qqbrowser geo error',
                        type: _this8.type
                    }, _this8.keeper.getToken());
                }
            }, function () {
                fail({
                    message: 'qqbrowser geo fail',
                    type: _this8.type
                }, _this8.keeper.getToken());
            });
        } catch (e) {
            fail({
                code: 400,
                message: e && e.message || JSON.stringify(e),
                type: _this8.type
            }, _this8.keeper.getToken());
        }
    });
};

var instance$7 = new QQBrowser();
var _interface$6 = instance$7.process.bind(instance$7);
_interface$6.type = instance$7.type;

function H5() {
    this.type = 'html';
    this.keeper = undefined;
}

H5.prototype.process = function (succ, fail, next) {
    var _this9 = this;

    var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // 预处理
    typeof succ == 'function' || (succ = this.noop);
    typeof fail == 'function' || (fail = this.noop);
    typeof next == 'function' || (next = this.noop);

    if (!this.supportGeo()) return next();
    opt.trigger = function (token) {
        fail({
            code: 408,
            message: _this9.type + " API Timeout:" + opt.timeout,
            type: _this9.type
        }, token);
    };
    this.keeper = new Keeper(opt);

    try {
        navigator.geolocation.getCurrentPosition(function (crd) {
            succ({
                lat: crd.coords.latitude,
                lng: crd.coords.longitude,
                type: _this9.type
            }, _this9.keeper.getToken());
        }, function () {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            fail({
                code: e.code == 1 && /https/.test(location.protocol) && 401, // http协议问题走错误日志查看
                message: (e.code || 'UNKOWN') + ": " + (e.message || 'h5 get location error'),
                type: _this9.type
            }, _this9.keeper.getToken());
        }, {
            enableHighAccuracy: config.get('enableHighAccuracy'),
            maximumAge: 30000, // 组件设置的默认缓存时间：30s
            timeout: config.get('timeout') || 10000
        });
    } catch (e) {
        fail({
            code: 400,
            message: e && e.message || JSON.stringify(e),
            type: this.type
        }, this.keeper.getToken());
    }
};
H5.prototype.supportGeo = function () {
    return !!navigator.geolocation;
};

var instance$8 = new H5();
var _interface$7 = instance$8.process.bind(instance$8);
_interface$7.type = instance$8.type;

var globalCount = 0;

var urlStringify = function urlStringify(url, data) {
    if (!data) {
        return url;
    }
    var param = [];
    for (var o in data) {
        if (data.hasOwnProperty(o)) {
            param.push(o + "=" + data[o]);
        }
    }
    return ~url.indexOf("?") ? url + '&' + param.join("&") : url + "?" + param.join("&");
};

/**
 * jsonp
 * */
function request(options) {

    if (!options.url) {
        throw new Error("url request!");
    }
    var data = options.data || {};
    var cb = options.onSuc || function () {};
    var cbName = data.callback = "WhereAmI" + ++globalCount + +new Date();

    var script = document.createElement("script");
    script.src = urlStringify(options.url, data);

    window[cbName] = function (res) {
        delete window[cbName];
        script.parentNode.removeChild(script);
        cb(res);
    };

    document.getElementsByTagName("head")[0].appendChild(script);
}

var Promise$1 = window.Promise || require('promise');

function DPcity() {
    this.cityType = 'dianping';
    this.GEOTYPE = ['wgs84', 'gcj02']; // map coordType: 1, 2
    this.keeper = undefined;
}
DPcity.prototype.process = function () {
    var _this10 = this;

    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // TODO: 城市超时缓存，目前被`promise`直接丢弃了
    return new Promise$1(function (resolve, reject) {
        // 说明：若超时未开启，最差情况：无thenable对象返回，不影响业务整体超时失败，只丢掉一次城市API失败上报
        opt.trigger = function (token) {
            reject({
                // code: 408,
                message: _this10.cityType + " city API Timeout: " + opt.timeout + "ms",
                type: _this10.type
            });
        };
        _this10.keeper = new Keeper(opt);

        request({
            url: "//mapi.dianping.com/getlocalcityid",
            data: {
                lat: position.lat,
                lng: position.lng,
                coordType: _this10.GEOTYPE.indexOf(position.geoType.toLowerCase()) + 1 || 1
            },
            onSuc: function onSuc() {
                var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (res.code == 200 && res.message) {
                    res.message.cityType = _this10.cityType;
                    resolve(res.message);
                } else {
                    reject({
                        message: _this10.cityType + " city API: fail"
                    });
                }
            }
        });
    });
};

var instance$9 = new DPcity();
var DPCity = instance$9.process.bind(instance$9);

var Promise$2 = window.Promise || require('promise');

function MTcity() {
    this.cityType = 'meituan';
    this.GEOTYPE = ['wgs84', 'gcj02'];
    this.keeper = undefined;
}

MTcity.prototype.process = function () {
    var _this11 = this;

    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var coordType = this.GEOTYPE.indexOf(position.geoType.toLowerCase());
    var url = location.protocol == 'https:' ? '//apimobile.meituan.com/group/v1/city/latlng/' : '//api.mobile.meituan.com/group/v1/city/latlng/';

    return new Promise$2(function (resolve, reject) {
        opt.trigger = function (token) {
            reject({
                // code: 408,
                message: _this11.cityType + " city API Timeout: " + opt.timeout + "ms",
                type: _this11.type
            });
        };
        _this11.keeper = new Keeper(opt);

        request({
            url: url + position.lat + ',' + position.lng,
            data: {
                tag: ~coordType ? coordType : 0
            },
            onSuc: function onSuc() {
                var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (res.data) {
                    var city = {
                        cityType: 'meituan',
                        cityid: res.data.id,
                        cityname: res.data.city
                    };
                    resolve(city);
                } else {
                    reject({
                        message: _this11.cityType + " city API: fail"
                    });
                }
            }
        });
    });
};

var instance$10 = new MTcity();
var MTCity = instance$10.process.bind(instance$10);

var Promise$3 = window.Promise || require('promise');

var GEOS = [_interface, _interface$1, _interface$2, _interface$3, _interface$4, _interface$5, // （TBS）补位API
_interface$6, // 1.浏览器 2.安卓微信&QQ补位API
_interface$7 // 兜底
];
var DIANPING = 'dianping';
var MEITUAN = 'meituan';

function Whereami() {
    this.isLocating = false;
    this.sucCallbackQueue = [];
    this.errorCallBackQueue = [];
}
Whereami.prototype.initData = function () {
    // config
    this.timeout = config.get('timeout') || 10000;
    this.disables = config.get('disables') || [];
    this.needCity = config.get('city');
    this.cityType = config.get('cityType');
    this.allowCache = !~this.disables.indexOf('cache'); // 说明：默认使用内存，只有`disables`能完全屏蔽`cache`API
    this.debug = /debug:whereami/i.test(location.href) || config.get('debug');

    this.apiTimeout = this.timeout; // 说明：目前统一设置为业务允许的最大值，灵活可控，组件内保留缓存策略

    // once
    this.isTimeout = false;
    this.timer = undefined;
    this.current = -1;
    this.onceStartTime = Date.now(); // 一次调用的开始时间
    LogClean(); // 根据采样率重置上报开关
};
Whereami.prototype.action = function (onSucc, onFail) {
    var _this12 = this;

    // 预处理
    onSucc = typeof onSucc == 'function' ? onSucc : this.noop;
    onFail = typeof onFail == 'function' ? onFail : this.noop;
    // 过滤爬虫
    if (this.isSpider()) return onFail();

    // 回调队列
    this.sucCallbackQueue.push(onSucc);
    this.errorCallBackQueue.push(onFail);

    // 检查状态: 业务并发调用控制阀
    if (this.isLocating) return;
    this.isLocating = true;
    // 初始化数据
    this.initData();
    // 计时器
    this.timer = setTimeout(function () {
        _this12.isTimeout = true;
        // GEO总体上报: 一次定位结束[3]
        Log(_this12.onceStartTime, 408); // 若全量使用缓存策略，统计数据GEO满足`408=201+409+416`等式
        // 业务回调
        _this12.execute(_this12.errorCallBackQueue, {
            code: 202,
            message: "Timeout: " + _this12.timeout + "ms"
        });
    }, this.timeout);

    // 开始定位
    this.next();
};
Whereami.prototype.processOn = function () {
    return !this.isTimeout || this.allowCache;
};
Whereami.prototype.next = function () {
    var _this13 = this;

    // API队列计数器
    this.current++;
    // 队列结束
    if (!GEOS[this.current]) {
        // GEO总体上报: 一次定位结束[4]
        Log(this.onceStartTime, this.isTimeout ? 416 : 417);
        // 超时
        if (this.isTimeout) return;
        clearTimeout(this.timer);
        // 业务回调
        return this.execute(this.errorCallBackQueue, {
            code: '204',
            message: 'No Geo Support'
        });
    }

    // 流程策略检查
    if (!this.processOn()) return;

    // API调用描述信息（闭包）
    var geoMethodType = GEOS[this.current].type;
    var startTime = Date.now();
    // API禁用（高优先级）
    if (~this.disables.indexOf(geoMethodType)) {
        return this.next();
    }
    // Debug
    this.debug && alert('start geos: ' + geoMethodType);
    // console.log('WhereAmI Geo Channel:', geoMethodType);

    GEOS[this.current](function (ret, token) {
        _this13.geoSuccHandle(ret, {
            customToken: token,
            originToken: startTime,
            geoMethodType: geoMethodType, // 备选
            startTime: startTime
        });
    }, function (err, token) {
        _this13.geoErrorHandle(err, {
            customToken: token,
            originToken: startTime,
            geoMethodType: geoMethodType, // 备选
            startTime: startTime
        });
    }, this.next.bind(this), {
        token: startTime, // 分发Token
        timeout: this.apiTimeout // API超时时长
    });
};
Whereami.prototype.validToken = function (custom, origin, geoMethodType) {
    try {
        if (!origin || !custom) return false;
        return new Date(origin).toString() == new Date(custom).toString();
    } catch (e) {
        return false;
    }
};
Whereami.prototype.validGeoRet = function (ret) {
    return !!(ret && parseFloat(ret.lat) && parseFloat(ret.lng));
};
Whereami.prototype.geoSuccHandle = function (ret, _ref2) {
    var customToken = _ref2.customToken,
        originToken = _ref2.originToken,
        geoMethodType = _ref2.geoMethodType,
        startTime = _ref2.startTime;

    // 校验token
    if (!this.validToken(customToken, originToken, geoMethodType)) {
        this.allowCache && _interface$1.set(ret); // 说明: API超时时长以业务为准，允许组件写入缓存；其他情况不追加结果
        return;
    }
    // API信息
    var geoType = ret.type || geoMethodType;
    // 校验数据
    var validRet = this.validGeoRet(ret);
    // API定位上报
    Log(startTime, validRet || 206, geoType);
    if (!validRet) {
        return this.next(); // 补位API继续定位，提升总体成功率（代价是平均时延增大）
    }
    // GEO总体上报: 一次定位结束[1]
    Log(this.onceStartTime, !this.isTimeout || 201);
    LogService(this.onceStartTime, ret);
    // 组件业务逻辑处理
    this.getPositionSuccess(ret, geoType);
};
Whereami.prototype.geoErrorHandle = function () {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref3 = arguments[1];
    var customToken = _ref3.customToken,
        originToken = _ref3.originToken,
        geoMethodType = _ref3.geoMethodType,
        startTime = _ref3.startTime;

    // 校验token
    if (!this.validToken(customToken, originToken, geoMethodType)) return;
    // API信息
    var geoType = err.type || geoMethodType;
    // API定位上报
    Log(startTime, err.code, geoType);
    if (~[400, 404, 407, 408, 412].indexOf(err.code)) {
        if (err.code == 400) {
            // 异常详情上报
            LogError(err, geoType, err.title || geoType + "-exception");
        } else if (err.code == 404) {
            // `enables`API定位失败详情上报
            LogError(err, geoType);
        }
        // 407: 设备未授权
        // 408: API超时
        // 412: 未命中
        return this.next(); // 使用补位API继续定位
    }
    // 401: `用户未授权`进入结束状态 -> 1) 用户不友好 2) 反馈至业务方（主要是html渠道）
    // GEO总体上报: 一次定位结束[2]
    Log(this.onceStartTime, this.isTimeout && 409);
    // 错误详情上报
    LogError(err, geoType);

    // 组件业务逻辑处理
    this.getPositionError(err);
};
Whereami.prototype.getPositionSuccess = function (ret, geoMethodType) {
    var _this14 = this;

    // 策略检查 (阶段1)
    if (!this.processOn()) return;

    // 数据处理
    ret.geoType || (ret.geoType = 'wgs84'); // 坐标系类型
    ret.type || (ret.type = geoMethodType); // 定位API类型
    // 缓存1: 经纬度
    this.allowCache && _interface$1.set(ret);

    // 城市接口
    this.needCity = this.needCity && (!ret.city || ret.city.cityType !== this.cityType);
    var _cityStartTime = Date.now();
    Promise$3.resolve(this.needCity && this.getCity(ret)).then(function (city) {
        // 城市接口统计，与业务超时无关
        city && Log(_cityStartTime, true, null, "city-" + _this14.cityType);
        // 策略检查 (阶段2, 可能是异步)
        if (!_this14.processOn()) return;
        // 计时清零
        clearTimeout(_this14.timer);
        // 城市数据处理、缓存、上报
        if (city) {
            try {
                ret.city = typeof city == 'string' && JSON.parse(city) || city;
                // 缓存2
                _this14.allowCache && _interface$1.set(ret);
            } catch (e) {}
        }
        // 消费回调队列
        _this14.isTimeout || _this14.execute(_this14.sucCallbackQueue, ret);
    }).catch(function () {
        var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        // 计时清零
        clearTimeout(_this14.timer);
        // 城市接口成功率统计
        Log(_cityStartTime, err.code, null, "city-" + _this14.cityType);
        // 消费回调队列: 包装code、message传给调用方
        _this14.isTimeout || _this14.execute(_this14.errorCallBackQueue, {
            code: 207,
            message: err.message
        });
    });

    // debug
    this.debug && alert(JSON.stringify(ret));
    console.log('succ channel:' + geoMethodType);
};
Whereami.prototype.getPositionError = function () {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var geoMethodType = arguments[1];

    // 超时
    if (this.isTimeout) return;
    // 计时清零
    clearTimeout(this.timer);
    // 业务回调
    this.execute(this.errorCallBackQueue, _extends(err, {
        code: '205' // 默认状态码
    }));
};
Whereami.prototype.getCity = function (ret) {
    var useMeituan = void 0;
    if (this.cityType == DIANPING) {
        useMeituan = false; // 显式设置优先于默认设置
    } else if (this.cityType == MEITUAN || /.meituan.(com|net)$/.test(location.hostname)) {
        this.cityType = MEITUAN;
        useMeituan = true;
    } else {
        this.cityType = DIANPING; // 默认用`点评`
    }
    var method = useMeituan ? MTCity : DPCity;
    return method(ret, {
        token: Date.now(), // 暂时不做校验
        timeout: this.apiTimeout
    });
};
Whereami.prototype.execute = function (queue) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    for (var i = 0, l = queue.length; i < l; i++) {
        try {
            queue.shift().apply(null, args);
        } catch (e) {}
    }
    this.endHandle();
};
Whereami.prototype.endHandle = function () {
    this.isLocating = false;
    this.sucCallbackQueue = [];
    this.errorCallBackQueue = [];
};
Whereami.prototype.isSpider = function () {
    return !!navigator.userAgent.match(/spider/i);
};
Whereami.prototype.noop = function () {};

var instance$11 = new Whereami();
var _interface$8 = instance$11.action.bind(instance$11);

_interface$8.cache = _interface$1.syncAPI;
_interface$8.url = _interface.syncAPI;
_interface$8.config = config;

module.exports = _interface$8;